import { Component } from 'react';
import DataTable from 'Container/DataTable/DataTableContainer';
import { ReactComponent as Android } from 'assets/images/svg/android.svg';
import { ReactComponent as Ios } from 'assets/images/svg/apple.svg';
import Image from 'Components/Common/Image';
import SendMessage from 'Container/Users/SendMessageContainer';
import dateFormat from 'dateformat';
import {  convertUTCTOLocalTimeStamp } from 'Components/Common/TimeStamp';
import { UsersFields as Fields, UsersSearchParams as SearchParams } from 'models/Users.model'
import { tableConstants } from 'Constants';
import Popup from 'Components/Common/PopUp';
import Request from 'Services/request';
import { usersListActions } from 'Actions';
import { toast as toastr } from 'react-toastify';
import { store } from 'Store';
export default class Usermgnt extends Component {
  constructor(props) {
    super(props);
    const model = {
      headers: [
        {
          className:tableConstants.USER_WIDTH,
          title: 'Name',
          chooseOption: { 
            name: SearchParams.nameSearch, //'firstNameSearch' /* API param name */,
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          combineapidata: [ 'name', 'image' ],
          accessor: Fields.name /* API response */,
          cell: rowDetails => {
            const { index, content, username, ...rest } = rowDetails;
            return (
              <td className={ tableConstants.USER_WIDTH } key={ index } /* onClick={ () => this.getActiveUser(username) } */>
                <div className='ctUserInfo'>
                  <div className='ctUserInfo_img'>
                    <Image imageToken={ rest.image } />
                  </div>
                  <div className="data_tooltip" tooltip={ content }>
                    <span className="ctUserInfo_name">
                      { content.length > 18 ? content.slice(0, 18) + '...' : content }
                    </span>
                  </div>
                  {' '}
                </div>
              </td>
            );
          },
          sortOption: true,
          isDataEncrypted: true,
        },
         {
          className:'w-20',
          title: 'Mobile Number',
          accessor: 'mobileNumber',
          // chooseOption: {
          //   name: 'mobileNumberdSearch',
          //   Component: 'Search',
          //   dispatchFunction: this.handleSearch,
          // },
          tooltip: true,
          sortOption: false,
          isDataEncrypted:true
        },
        {
          className:'w-20',
          title: 'Email',
          accessor: 'emailId',
          chooseOption: {
            name: 'emailIdSearch',
            Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          tooltip: true,
          sortOption: true,
          isDataEncrypted:true
        },
        {
          className:tableConstants.USER_WIDTH,
          title: 'Registered Date',
          accessor: 'registeredAt',
          chooseOption: {
            name: 'registeredAtSearch',
            Component: 'DateTimeRangeComponent',
            dispatchFunction: this.handleDateSearch,
          },
          cell: function (rowDetails) {
            const { index, content } = rowDetails;
            const val = content && content.replace('T',' ')
            const time = content && convertUTCTOLocalTimeStamp(val)
            return (
              <td key={ index } className={ tableConstants.USER_WIDTH }>
                {content && dateFormat(time, 'mmm d, yyyy / hh:MM:ss TT ')}
              </td>
            );
          },
          sortOption: true,
        },
        {
          title: 'Device Platform',
          chooseOption: {
            name: 'deviceTypeSearch',
            Component: 'DropDown',
            dispatchFunction: this.handleSearch,
            optionRender: this.props.device,
            DropdownText:'All'
          },
          accessor: 'deviceType',
          cell: function(rowDetails) {
            const { content, index, deviceVersion } = rowDetails;
            const contentToDisplay = content === 'ios' ? 'iOS' : content;
            const deviceType =
              content && content !== '' ? (
                <>
                  <i className='android'>
                    { content === 'android' ? <Android /> : content === 'ios' ? <Ios /> : '' }
                  </i>
                  {contentToDisplay} { ` ${ content !== 'web' ? deviceVersion : '' } ` }
                </>
              ) : ( 'web' );
            return <td key={ index }>{deviceType}</td>;
          },
          sortOption: true,
        },
        {
          title: 'Action',
          accessor: 'id',
          cell: rowDetail => {
            const { index, id, rowIdx, profile, ...rest } = rowDetail;
            const lable = rowDetail?.isBlock === 0 ? 'Block' : 'UnBlock'
            return (
              <td key={ index } data-row={ rowIdx } >
                <div className={ rowDetail.isBlock === 0 ? 'block-action' : 'unblock-action' } onClick={ () => this.openPopUp(rowDetail) } >
                  {lable}
                </div>
              </td>
            );
          }
        }
      ],
      sendMessageForm: false,
      activeEditData: '',
    };
    this.state = model;
  }

  handleSearch = event => {
    const { name, value } = event.target;
    this.props.formUrl(name, value);
  };

  handleDateSearch = (data) => {
    for (const [ key, value ] of Object.entries(data)) {
      this.props.formUrl(key, value);
    }
  };

   closePopUp = event => {
      event.preventDefault();
      this.setState({
        deletepopup: false
      });
    };

   openPopUp = (rowDetail) => {
    this.setState({
      deletepopup: true,
      userId: rowDetail.username,
      isBlock: rowDetail.isBlock
    });
    
  };

  /**
   * @method sortTable
   * @summary sort for view data
   * @param {name} sortAttribite - Query string name
   * @return { function } formUrlSort
   */
  sortTable = (sortAttribite) => {
    const { activeSort } = this.props
    const sortType = (activeSort.id === sortAttribite) ? 
    ((activeSort.value && activeSort.value == 'desc') ? 'asc' : 'desc') : 'asc';
    this.props.formUrlSort({ id: sortAttribite, value: sortType });
  }

  // getActiveUser = (username) => {
  //   this.props.getActiveUserData(username);
  // };

  sendMessage = (data) => {
    this.setState({ activeEditData: data, sendMessageForm: true })
  }

  /**
   * @method closeForm
   * @summary close send message form
   * @return { object } updated domain state
   */
  closeForm = () => {
    this.setState({ sendMessageForm: false });
  };
 
  toggleblockUser = (userId, isBlock) => {
  
    if (!userId) {
      toastr.error('Reported Mobile Number is Required');
      return;
    }

    Request.update(`/reports/action`, {
      reportedUser: userId,
      isBlocked: isBlock === 1 ? 0 : 1
    })
      .then((response) => {
        const { message, data: { isBlock } } = response;
        toastr.dismiss();
        toastr.success(message);

        this.setState({ 
          deletepopup: false, 
          isBlock 
        }, () => {
          // Dispatch the action to refetch user list
          store.dispatch(usersListActions.fetchUsersList());
        });

      }).catch((error) => {
        toastr.error(error.toString());
      });
  }

  render() {
    const { usersList, loading } = this.props;
    const { sendMessageForm,deletepopup,userId,isBlock } = this.state;
    return (
      <>
        <div className='grid'>
          {sendMessageForm && (
            <SendMessage
              closeForm={ this.closeForm }
              { ...this.state.activeEditData }
            />
          )}
          <div className='responsive-table userrequest ctTableBox'>
            <DataTable
              className='data-table'
              tableClassName ='col-s'
              headers={ this.state.headers }
              data={ usersList }
              noData='No records!'
              loading={ loading }
              sortTable = { this.sortTable }
              activeSort={ this.props.activeSort }
              // className = { `clickable-tr` }
              // clickableTR = { [ { dispachFunction: this.getActiveUser, parameter: 'username' } ] }
            />
            {this.props.pagination}
          </div>
          { deletepopup && (
            <Popup
            popupText={ `Are you sure you want to ${ isBlock ? 'Unblock' : 'Block' } this user?` }
            handleYes={ () => this.toggleblockUser(userId,isBlock) }
            handleCancel={ this.closePopUp }
            />
          )
          }
        </div>
      </>
    );
  }
}
